import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { Chip } from './Chip';
export const InputChip = createPolymorphicComponent(forwardRef(function InputChip(props, forwardedRef) {
    return _jsx(Chip, { ...props, ref: forwardedRef, variant: 'input' });
}));
